export default {"src":"/_next/static/media/burger.bad482ed.svg","height":12,"width":18};